// ContractHistory.jsx
// History Tab timeline component for Contract Details Drawer

import React from "react";
import { Clock, CheckCircle2, AlertTriangle, FilePlus, RefreshCw, XCircle } from "lucide-react";

const getEventIcon = (event = "") => {
  const lower = event.toLowerCase();
  if (lower.includes("created")) return <FilePlus size={15} className="text-blue-500" />;
  if (lower.includes("renew")) return <RefreshCw size={15} className="text-emerald-500" />;
  if (lower.includes("probation") || lower.includes("completed")) return <CheckCircle2 size={15} className="text-emerald-500" />;
  if (lower.includes("expiring")) return <AlertTriangle size={15} className="text-amber-500" />;
  if (lower.includes("expired") || lower.includes("terminated")) return <XCircle size={15} className="text-rose-500" />;
  return <Clock size={15} className="text-slate-400" />;
};

const ContractHistory = ({ history = [] }) => {
  if (!history || history.length === 0) {
    return (
      <div className="py-8 text-center text-xs text-slate-400">
        No contract history recorded yet.
      </div>
    );
  }

  return (
    <div className="space-y-6 pt-2">
      <div className="relative pl-6 before:absolute before:left-2.5 before:top-2 before:bottom-2 before:w-0.5 before:bg-slate-200">
        {history.map((item, idx) => (
          <div key={item.id || idx} className="relative mb-6 last:mb-0">
            {/* Timeline Dot */}
            <div className="absolute -left-6 top-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-white ring-4 ring-slate-50 border border-slate-200">
              {getEventIcon(item.event)}
            </div>

            {/* Event Item Card */}
            <div className="rounded-xl border border-slate-200/80 bg-slate-50/50 p-3.5">
              <div className="flex items-center justify-between">
                <h4 className="text-xs font-semibold text-slate-800">
                  {item.event}
                </h4>
                <span className="text-[10px] text-slate-400 font-medium">
                  {item.date}
                </span>
              </div>

              {item.description && (
                <p className="mt-1.5 text-xs text-slate-600 leading-relaxed">
                  {item.description}
                </p>
              )}

              {item.performed_by && (
                <div className="mt-2 text-[10px] text-slate-400 font-medium">
                  Performed by: <span className="text-slate-600">{item.performed_by}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContractHistory;
